import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

import { useParams } from "react-router-dom";
import { N1PlansEditCard } from "./edit_card";

export const N1PlansEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full relative">
      <div className="flex flex-col gap-10 p-10">
        <N1PlansEditCard id={Number(id)} client={Clients.N1} />
        <AuditCard
          id={Number(id)}
          client={Clients.N1}
          audit_table_name={`${Tables.N1_PLANS}`}
        />
      </div>
    </div>
  );
};
